<ul class="nav tab-list">
    <li class="nav-item" *ngFor="let tab of tabs">
        <a [ngClass]="{'selected':tab.selected}" (click)="selectTab(tab)">{{tab.title}}</a>
    </li>  
</ul>